// src/context/KnowledgeBaseView.jsx
//
// The Knowledge Base page body (KB-main-docs.png): the "Connettori" card on
// top and the Document Library below — both `SectionCard`s since 2026-09-27 (the
// Gestione Workspace look). One component for the three mounts —
// member (/knowledge-base), tenant-admin (/tenant-admin/knowledge-base) and
// superadmin (/admin/knowledge-base, tenant dropdown) — keyed on an explicit
// tenantId like DocumentsView.
//
// The site card is gated on canWrite because EVERY Site Manager endpoint is
// tenant-admin, the GETs included: a member sees the library only.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Library } from 'lucide-react';
import SiteConnectorCard from './site/SiteConnectorCard.jsx';
import DocumentsView from './DocumentsView.jsx';
import SectionCard, { CARD_BODY } from '../components/ui/SectionCard.jsx';
import { COLORS, FONT_SANS, RADII } from '../constants/theme.js';

export default function KnowledgeBaseView({ tenantId, canWrite = false, userKey = '' }) {
  const { t } = useTranslation('context');

  if (!tenantId) {
    return <div style={emptyBox}>{t('noTenant')}</div>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      {canWrite && <SiteConnectorCard tenantId={tenantId} userKey={userKey} />}

      <SectionCard
        as="section"
        icon={Library}
        title={t('documents.libraryTitle')}
        subtitle={t('documents.librarySubtitle')}
      >
        <div style={CARD_BODY}>
          <DocumentsView tenantId={tenantId} canWrite={canWrite} />
        </div>
      </SectionCard>
    </div>
  );
}

const emptyBox = {
  padding: '60px 40px', textAlign: 'center', background: COLORS.surface,
  borderRadius: RADII.control, border: `1px solid ${COLORS.border}`,
  color: COLORS.textSecondary, fontSize: '13px', fontFamily: FONT_SANS,
};
